function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, message } from "antd";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var NewDepartment = function NewDepartment(_ref) {
  var handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    userOptions = _useState8[0],
    setUserOptions = _useState8[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('label', values.label);
    formData.append('user_id', values.user_id);
    axios.post(Common.baseApiUrl + 'adddepartment', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getplatformusers/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        response.data.users.forEach(function (u) {
          setUserOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: u.firstname + " " + u.lastname,
              value: u.id
            }]);
          });
          form.setFieldsValue({
            user_id: userOptions
          });
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 5
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "label",
        label: "Nom d\xE9partement",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "user_id",
        label: "Personne responsable",
        children: /*#__PURE__*/_jsx(Select, {
          options: userOptions,
          placeholder: "Choisir un responsable"
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: userOptions.length == 0,
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: "Cr\xE9er"
        })
      })]
    })]
  });
};
export default NewDepartment;